import { Link } from "react-router-dom"
import "../styles/home.css"
import Slideshow from "./common/Slideshow"
import BottomSlider from "./BottomSlider"
import { Helmet } from "react-helmet-async";
   
export default function Home(){

    
  
    return (
         <>

                 <Helmet>
                    <title>ELEKTROMATERIJAL, SKLOPNA TEHNIKA I RELEJNA OPREMA – Prodex</title>
                    <meta 
                    name="description" 
                    content="DOO Prodex iz Modriče nudi širok asortiman elektromaterijala, sklopne tehnike i relejne opreme. 
                    Kupujte kvalitetne proizvode online ili posjetite našu trgovinu." 
                    />
                    <link rel="canonical" href="https://prodexmd.ba/" />
                    <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Organization",
                        "name": "Prodex",
                        "url": "https://prodexmd.ba/",
                        "logo": "https://prodexmd.ba/logo.png"
                    })}
                    </script>
                </Helmet>
                <Slideshow/>
                 

                <div className="containernew">
                    <div className="titleHome">
                        <h1>ELEKTROMATERIJAL SKLOPNA TEHNIKA
                            <br></br>I RELEJNA OPREMA
                        </h1>
                    </div>
                    <div className="brandbox-container"> 
                         
                            <div className="brandbox">

                                 <a
                                    href={`/productscatalogs/68626178a81af402ecf4db42`}
                                    
                                    className="product-name-link"
                                >
                                    <img src="/images/brands/FINDER.png" className="img-finder" alt="hero"/>
                                    <h1>RELEJI FINDER</h1>
                                </a>
                                <p>DOO Prodex iz Modriče je distributer i uvoznik za BiH Finder releja.<br></br><br></br>
                                
                                -Industrijski releji <br></br>
                                -PLC OPTO Releji <br></br>
                                -Slim releji <br></br>
                                -Solid state releji <br></br>
                                -Impulsivni releji <br></br>
                                -Vremenski releji<br></br>
                                -Releji za nivo<br></br>
                                -Releji zvijezda trougao <br></br>
                                -Releji asimetrije faza <br></br>
                                -Termistorski releji <br></br>
                                -Postolje za releje        
                                    </p>
                                {/* <Link   to={"/productscatalogs/68626178a81af402ecf4db42" } role="button" className="brands-button">Detaljnjije</Link>  */}
                                
                            </div>
                            <div className="brandbox">
                                <a
                                    href={`/productscatalogs/688f77077cd6a6af49050415`}
                                    
                                    className="product-name-link"
                                >
                                    <img src="/images/brands/ls-logo.jpg" className="img-ls" alt="hero"/>
                                    <h1>LS ELECTRIC SKLOPNA TEHNIKA</h1>
                                </a>
                            <p>DOO Prodex iz Modriče je uvoznik brenda LS ELECTRIC<br></br> 
                                iz Južne Koreje.<br></br><br></br>
                            <h2 className="contactorsLinks"><a  href={`/productscatalogs/688f98212087ee1380f15284`}>
                                - Kontaktori i bimetalni releji METASOL
                            </a></h2> 
                             <h2 className="contactorsLinks">
                              <a href={`/productscatalogs/68ae0ba74d3d0e6743e220ab/products`}>
                                - Kontaktori i Bimetalni releji serije MINI
                              </a>
                            </h2> 
                             <h2 className="contactorsLinks">
                               <a  href={`/productscatalogs/68c81ec0e4bbd2485bd86536/products`}>
                                - Modularni kontaktori
                              </a>
                            </h2>  
                            <h2 className="contactorsLinks">
                              <a href={`/productscatalogs/6918b90384175a270c6d1fd6`}>
                                - AS kompaktni prekidači
                            </a>
                            </h2>  

                            <h2 className="contactorsLinks">
                               <a  href={`/productscatalogs/6890d6bfa3a4cd85c785216e`}>
                                - Motorne zaštitne sklopke MMS
                               </a>
                            </h2> 

                            <h2 className="contactorsLinks">
                                <a  href={`/productscatalogs/68ca53857a7658620768fb33/products`}>
                                    - Frekventni regulatori
                                </a>
                            </h2>
                         
                            
                            {/* Kontaktori za upravljanje i uključenje električnih <br></br>
                            potrošača različitih upravljačkih napona. <br></br><br></br>
                            LSIS bimetali  - serija Metasol: Njihov dizajn <br></br>
                            demonstrira superiornu tehnologiju. <br></br><br></br>
                            LS Meta-MEC Motorna zaštitna sklopka pruža više <br></br>
                            efikasnosti kroz razne funkcije i kompaktan dizajn. */}
                                    </p>
                                {/* <div className="buttonProba"><Link to={"/productscatalogs/688f77077cd6a6af49050415" } role="button" className="brands-button">Detaljnjije</Link></div>  */}

                            
                        </div>
                        
                            <div className="brandbox">
                                <a
                                    href={`/productscatalogs/6880f532686d08b00444ebb6`}
                                    
                                    className="product-name-link"
                                >
                                    <img src="/images/brands/aling-logo.png" className="img-aling" alt="hero"/>
                                    <h1>ALING CONEL</h1>
                                </a><br></br>

                                
                                <h2 className="contactorsLinks">
                                    <a  href={`/productscatalogs/6926c046b6fe3ee52e690953/products`}>
                                    - Aling Conel Prestige line
                                    </a>
                                </h2> 
                                
                                <h2 className="contactorsLinks">
                                    <a  href={`/productscatalogs/6926da96de714e5991656ffc/products`}>
                                    - Aling Conel EON
                                    </a>
                                </h2> 

                                
                                <h2 className="contactorsLinks">
                                    <a  href={`/productscatalogs/6926e04a21e71e0369cd0069/products`}>
                                    - Aling Conel Sklopke za kupatilo
                                    </a>
                                </h2> 

                                
                                <h2 className="contactorsLinks">
                                    <a  href={`/productscatalogs/6880f70f5cc45ff126d164f4/products`}>
                                    - Aling Conel ALING MODE
                                    </a>
                                </h2> 
                                    
                                <h2 className="contactorsLinks">
                                    <a  href={`/productscatalogs/6880f9f3e5f11ee7442c1682/products`}>
                                    - Aling Conel POWER LINE
                                    </a>
                                </h2> 
                                    
                                <h2 className="contactorsLinks">
                                    <a  href={`/productscatalogs/6880fa6ee5f11ee7442c1698/products`}>
                                    - Aling Conel Aling OG
                                    </a>
                                </h2> 
                                    
                                <h2 className="contactorsLinks">
                                    <a  href={`/productscatalogs/6880facde5f11ee7442c16a9/products`}>
                                    - Aling Conel ARMOUR Line
                                    </a>
                                </h2> 
                                  <h2 className="contactorsLinks">
                                    <a  href={`/productscatalogs/688e32f505ba48977427242d/products`}>
                                    - Aling Conel Utikači i priključnice
                                    </a>
                                </h2> 
                                  <h2 className="contactorsLinks">
                                    <a  href={`/productscatalogs/6882857298855ea5638ce419/products`}>
                                    - Aling Conel Produžni kablovi
                                    </a>
                                </h2> 
                                 <h2 className="contactorsLinks">
                                    <a  href={`/productscatalogs/688287f623cd1008b3d50208/products`}>
                                    - Aling Conel Sijalična grla
                                    </a>
                                </h2> 
                                {/* <p>Širok asortiman proizvoda, modela i boja, pruža
                                vam <br></br>mogućnost za razne kombinacije koje će<br></br>
                                svaki zid učiniti lepšim. ALING-CONEL sklopke i <br></br>
                                priključnice dotatno oplemenjuje svaki prostor i <br></br>
                                pored upotrebne, imaju i dekorativnu funkciju. <br></br>
                                Jednostavnost forme predstavljena je u <br></br>
                                elegantnoj liniji PRESTIGE LINE. <br></br>
                                PRESTIGE LINE karakterišu visokokvalitetni<br></br>
                                materijali, jednostavna tehnička rešenja i <br></br>
                                izuzetno laka ugradnja. 
                                </p> */}

                                {/* <Link   to={"/productscatalogs/6880f532686d08b00444ebb6" }   role="button" className="brands-button">Detaljnjije</Link>  */}
                            </div>
                            <div className="brandbox">
                                <a
                                    href={`/productscatalogs/687cabdc01b1d0722774b351`}
                                    
                                    className="product-name-link"
                                >
                                    {/* <h2 className="rezDel">PRODEX</h2> */}
                                    <h1>REZERVNI DIJELOVI BIJELE TEHNIKE</h1>
                                </a><br></br>

                                <h2 className="contactorsLinks">
                                    <a  href={`/productscatalogs/687caadb8a799be24966bfea`}>
                                    - Rezervni dijelovi veš mašine
                                    </a>
                                </h2> 
                                <h2 className="contactorsLinks">
                                    <a  href={`/productscatalogs/6880b369eed5cc52552530ba/products`}>
                                    - Rezervni dijelovi mašine za suđe
                                    </a>
                                </h2> 
                                <h2 className="contactorsLinks">
                                    <a  href={`/productscatalogs/687ccb304850c622dec70680/products`}>
                                    - Rezervni dijelovi mašine za sušenje veša
                                    </a>
                                </h2> 
                                <h2 className="contactorsLinks">
                                    <a  href={`/productscatalogs/6863f0f78afbb500cd7ac3d0`}>
                                    - Rezervni dijelovi šporeta
                                    </a>
                                </h2> 
                                 <h2 className="contactorsLinks">
                                    <a  href={`/productscatalogs/687fb95a7c7912750d8cf5b1/products`}>
                                    - Rezervni dijelovi friteze
                                    </a>
                                </h2> 
                                 <h2 className="contactorsLinks">
                                    <a  href={`/productscatalogs/687fbc037c7912750d8cf67a/products`}>
                                    - Rezervni dijelovi profesionalnog šporeta
                                    </a>
                                </h2> 
                                 <h2 className="contactorsLinks">
                                    <a  href={`/productscatalogs/68a020f8f7f9227010877153`}>
                                    - Rezervni dijelovi bojlera
                                    </a>
                                </h2> 
                                 <h2 className="contactorsLinks">
                                    <a  href={`/productscatalogs/68a34d60f8b40d7aa71f00c3/products`}>
                                    - Rezervni dijelovi kotla
                                    </a>
                                </h2> 
                                 <h2 className="contactorsLinks">
                                    <a  href={`/productscatalogs/68810e9d850370fb60e259b4`}>
                                    - Rezervni dijelovi frižidera
                                    </a>
                                </h2> 
                                 <h2 className="contactorsLinks">
                                    <a  href={`/productscatalogs/6880d14c08861f7ab19cb5d2/products`}>
                                    - Rezervni dijelovi TA peći, radijatora i kvarcne grijalice
                                    </a>
                                </h2> 
                                <h2 className="contactorsLinks">
                                    <a  href={`/productscatalogs/688100e426597a01c8ce8ff5/products`}>
                                    - Rezervni dijelovi usisivača
                                    </a>
                                </h2> 
                                <h2 className="contactorsLinks">
                                    <a  href={`/productscatalogs/692dee18ae878ab5ff39249d/products`}>
                                    - Kondenzatori
                                    </a>
                                </h2> 

                                {/* <p className="full-width-text">Preduzeće "PRODEX" d.o.o specijalizovano je za<br></br>
                                promet rezervnih dijelova za bijelu tehniku. 
                                Nekoliko godina u nazad smo lideri u toj oblasti 
                                u BIH. U našoj ponudi možete pronaći rezervne  
                                dijelove svih svijetskih proizvođača bijele  
                                tehnike kao što su Beko, Aristan, Gorenje, Askol,  
                                Ametek, Cebi, Ducati, Irca, Thermopower  
                                Thermowatt, Reco, SKF.
                                
                                
                                </p> */}
                                {/* <Link   to={"/productscatalogs/687cabdc01b1d0722774b351" }  role="button" className="brands-button">Detaljnjije</Link>  */}
                            
                        </div>
                </div>
                 
                </div>

                {/* <BottomSlider  /> */}

                                  
         </>
    )
}

 